import {UserCRUDRecord} from "@commons/mapping/UserCRUDRecord";
import {UseFormReturn} from "react-hook-form/dist/types";
import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {TokenRecord} from "@commons/mapping/TokenRecord";
import {selectToken, selectUser} from "@commons/core.slice";
import React, {useState} from "react";
import {SignInState} from "../features/signIn/SignInCard3";
import {useForm} from "react-hook-form";
import {cambioPassword} from "@commons/actions/authentication.action";
import {cambioPasswordUtente} from "@commons/actions/user.action";
import md5 from "md5";

export type ChangePasswordFormData = {
    currentPassword: string;
    nuovaPassword: string;
    ripetiPassword: string;
    emailPersonale: string;
};

type ChangePasswordMethod = 'byToken' | 'byIdUser';

export function useFormChangePassword(method: ChangePasswordMethod, onSuccess?: (strMessage: string) => void, onError?: (strMessage: string) => void): {
    user: UserCRUDRecord | null,
    onSubmitHandler: (e?: React.BaseSyntheticEvent) => void,
    useFormReturn: UseFormReturn<ChangePasswordFormData, any>,
    status: SignInState,
    statusMsg: string,
} {
    const dispatch = useAppDispatch();
    const localToken: TokenRecord | null = useAppSelector(selectToken);
    const user: UserCRUDRecord | null = useAppSelector(selectUser);

    const [status, setStatus] = useState<SignInState>('READY');
    const [statusMsg, setStatusMsg] = useState<string>('');

    const defaultValues: ChangePasswordFormData = {
        currentPassword: '',
        nuovaPassword: '',
        ripetiPassword: '',
        emailPersonale: (user && user.email) ? user.email : '',
    }
    const useFormReturn = useForm<ChangePasswordFormData>({mode: "onTouched", defaultValues});

    const onSubmitHandler = (e?: React.BaseSyntheticEvent) => {
        useFormReturn.handleSubmit(changePassword)(e).then(
            () => {
                if (onSuccess) {
                    onSuccess(`Password modificata correttamente!`);
                }
            },
            () => {
                if (onError) {
                    onError(`Errore generico! Contattare l'assistenza`);
                }
            });
    }

    function changePassword(data: ChangePasswordFormData) {
        return new Promise<string>((resolve, reject) => {
            setStatus('CHECKING');
            let promise;
            if (method === 'byToken')
                promise = dispatch(cambioPassword({
                    token: localToken?.token!,
                    passwordInChiaro: data.nuovaPassword!,
                    email: data.emailPersonale ? data.emailPersonale : undefined,
                }))
            else
                promise = dispatch(cambioPasswordUtente({
                    currentPassword: data.currentPassword,
                    idUser: user?.idUser!,
                    password: md5(data.currentPassword!),
                    passwordInChiaro: data.nuovaPassword,
                }))
            promise.then((res) => {
                console.log('Type: ', res.type);
                if (res.type === cambioPassword.fulfilled.type || res.type === cambioPasswordUtente.fulfilled.type) {
                    setStatus('SUCCESS');
                    // @ts-ignore
                    if (res.payload.email && res.payload.emailVerificata === 1) {
                        setStatusMsg(`Ti è stata inviata un'email con il link per l'attivazione dell'account all'indirizzo: ${data.emailPersonale}`);
                    } else {
                        setStatusMsg(`Password modificata correttamente!`);
                    }
                    resolve('ok');
                } else if (res.type === cambioPassword.rejected.type || res.type === cambioPasswordUtente.rejected.type) {
                    setStatus('FAILED');
                    // @ts-ignore
                    if (res.payload && res.payload.data && res.payload.data.message) {
                        // @ts-ignore
                        setStatusMsg(res.payload.data.message);
                        // @ts-ignore
                        //throw new Error(res.payload.data.message);
                    } else {
                        setStatusMsg(`Errore generico! Contattare l'assistenza`);
                        //throw new Error(`Errore generico! Contattare l'assistenza`);
                    }
                    reject('error');
                }
            }, () => {
                // NON CI VIENE MAI!!!
            });
        });
    }

    return {user, onSubmitHandler, useFormReturn, status, statusMsg};
}